import React, { useContext, useEffect, useState } from "react";
import { Tabs, Card } from "@shopify/polaris";

// import helper
import { baseHelper } from "lib/helpers";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";

// import context
import { PrivateContext } from "lib/context";

// import tab prop
import { tabProp } from "app/product/modules/generic/propTypes";
import { ProductProvider } from "app/product/modules/generic/context/index";

// import data
import editData from "app/product/modules/operator/features/edit/config/editData";

// import tab
import EditAttachment from "./attachment";
import EditFulfillment from "./fulfillment";
import EditImage from "./image";
import EditInformation from "./information";
import EditInventory from "./inventory";
import EditMetafield from "./metafield";
import EditVariant from "./variant";

const EditTabs = (props) => {
  const { setBanner, setDescription, setTitle, isVariant, refetch, isMetafield } = props;
  const { cms, currentUser, history } = useContext(PrivateContext);
  const { isAttachmentVisible = false } = currentUser || {};
  const { search } = history.location;
  const { tab } = baseHelper.getQueryParams(search);
  const { ATTACHMENT, FULFILLMENT, IMAGE, INFORMATION, INVENTORY, VARIANT, METAFIELD } = constant;
  const tabData = { isAttachmentVisible, isMetafield, isVariant };
  const validProductTabs = editData(cms, tabData).tabs;
  const [selected, setSelected] = useState("");
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    const validtab = validProductTabs.map((item) => item.id);
    const tabName = validtab.includes(tab) ? tab : INFORMATION;
    setSelected(tabName);
    if (!validtab.includes(tab)) {
      baseHelper.setUrl(history, { tab: tabName });
    }
  }, [INFORMATION, history, selected, tab, validProductTabs]);

  useEffect(() => {
    let index = validProductTabs.findIndex((item) => item.id === tab);
    if (validProductTabs.length < index) {
      index = 0;
    }
    setSelectedTabIndex(index);
  }, [tab, validProductTabs]);

  const handleTabChange = (tabIndex) => {
    const tabId = validProductTabs[tabIndex].id;
    setSelected(tabId);
    baseHelper.setUrl(history, { tab: tabId });
  };

  const getTab = (tabSelected) => {
    let lastTab = isAttachmentVisible ? ATTACHMENT : FULFILLMENT;
    if (isVariant) {
      lastTab = isAttachmentVisible ? ATTACHMENT : VARIANT;
    }

    if (isMetafield) {
      lastTab = isAttachmentVisible ? ATTACHMENT : METAFIELD;
    }

    const tabObj = { islastTab: tabSelected === lastTab };

    switch (tabSelected) {
      case INFORMATION:
        return <EditInformation />;
      case INVENTORY:
        return <EditInventory />;
      case IMAGE:
        return <EditImage />;
      case VARIANT:
        return <EditVariant tabObj={tabObj} />;
      case FULFILLMENT:
        return <EditFulfillment tabObj={tabObj} />;
      case ATTACHMENT:
        return <EditAttachment tabObj={tabObj} />;
      case METAFIELD:
        return <EditMetafield tabObj={tabObj} />;
      default:
        return <EditInformation />;
    }
  };
  const tabLength = validProductTabs.length;
  const tabValue = selectedTabIndex >= tabLength ? tabLength - 1 : selectedTabIndex;

  return (
    <>
      <Card>
        <Tabs tabs={validProductTabs} selected={tabValue > 0 ? tabValue : 0} onSelect={handleTabChange} />
      </Card>
      <ProductProvider
        value={{
          handleTabChange,
          isVariant,
          refetch,
          setBanner,
          setDescription,
          setTitle,
        }}
      >
        <div className="productComponent">{getTab(selected)}</div>
      </ProductProvider>
    </>
  );
};

EditTabs.propTypes = tabProp.type;

export default withFeature(withErrorBoundary(EditTabs), {
  feature: constant.PRODUCT_UPDATE_FORM,
  // subFeature: constant.PRODUCT_UPDATE_FORM,
});
